var d = require("comment-regex");
module.exports = function (f) {
  f.StrippedLambertMaterial = function (h) {
    let j = new f.ShaderMaterial({
      name: "lambert-stripped",
      uniforms: f.UniformsUtils.merge([f.ShaderLib.lambert.uniforms]),
      lights: true,
      fog: true,
      vertexShader:
        "\n                #define LAMBERT\n                varying vec3 vLightFront;\n                varying vec3 vIndirectFront;\n                #ifdef DOUBLE_SIDED\n                    varying vec3 vLightBack;\n                    varying vec3 vIndirectBack;\n                #endif\n                #include <common>\n                #include <uv_pars_vertex>\n                #include <uv2_pars_vertex>\n                // #include <envmap_pars_vertex>\n                #include <bsdfs>\n                #include <lights_pars_begin>\n                #include <color_pars_vertex>\n                #include <fog_pars_vertex>\n                // #include <morphtarget_pars_vertex>\n                // #include <skinning_pars_vertex>\n                #include <shadowmap_pars_vertex>\n                // #include <logdepthbuf_pars_vertex>\n                // #include <clipping_planes_pars_vertex>\n                void main() {\n                    #include <uv_vertex>\n                    #include <uv2_vertex>\n                    #include <color_vertex>\n                    #include <beginnormal_vertex>\n                    // #include <morphnormal_vertex>\n                    // #include <skinbase_vertex>\n                    // #include <skinnormal_vertex>\n                    #include <defaultnormal_vertex>\n                    #include <begin_vertex>\n                    // #include <morphtarget_vertex>\n                    // #include <skinning_vertex>\n                    #include <project_vertex>\n                    // #include <logdepthbuf_vertex>\n                    // #include <clipping_planes_vertex>\n                    #include <worldpos_vertex>\n                    // #include <envmap_vertex>\n                    #include <lights_lambert_vertex>\n                    #include <shadowmap_vertex>\n                    #include <fog_vertex>\n                }\n                ",
      fragmentShader:
        "\n                uniform vec3 diffuse;\n                uniform vec3 emissive;\n                uniform float opacity;\n\n                varying vec3 vLightFront;\n                varying vec3 vIndirectFront;\n\n                #ifdef DOUBLE_SIDED\n                    varying vec3 vLightBack;\n                    varying vec3 vIndirectBack;\n                #endif\n\n\n                #include <common>\n                #include <packing>\n                // #include <dithering_pars_fragment>\n                #include <color_pars_fragment>\n                #include <uv_pars_fragment>\n                #include <uv2_pars_fragment>\n                #include <map_pars_fragment>\n                // #include <alphamap_pars_fragment>\n                #include <aomap_pars_fragment>\n                #include <lightmap_pars_fragment>\n                #include <emissivemap_pars_fragment>\n                // #include <envmap_pars_fragment>\n                #include <bsdfs>  // Shading functions\n                #include <lights_pars_begin>\n                #include <fog_pars_fragment>\n                #include <shadowmap_pars_fragment>\n                #include <shadowmask_pars_fragment>\n                // #include <specularmap_pars_fragment>\n                // #include <logdepthbuf_pars_fragment>\n                // #include <clipping_planes_pars_fragment>\n\n                void main() {\n\n                    // #include <clipping_planes_fragment>\n\n                    vec4 diffuseColor = vec4( diffuse, opacity );\n                    ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n                    vec3 totalEmissiveRadiance = emissive;\n\n                    // #include <logdepthbuf_fragment>\n                    #include <map_fragment>\n                    #include <color_fragment>\n                    // #include <alphamap_fragment>\n                    #include <alphatest_fragment>\n                    // #include <specularmap_fragment>\n                    #include <emissivemap_fragment>\n\n                    // accumulation\n                    reflectedLight.indirectDiffuse = getAmbientLightIrradiance( ambientLightColor );\n\n                    #ifdef DOUBLE_SIDED\n\n                        reflectedLight.indirectDiffuse += ( gl_FrontFacing ) ? vIndirectFront : vIndirectBack;\n\n                    #else\n\n                        reflectedLight.indirectDiffuse += vIndirectFront;\n\n                    #endif\n\n                    #include <lightmap_fragment>\n\n                    reflectedLight.indirectDiffuse *= BRDF_Diffuse_Lambert( diffuseColor.rgb );\n\n                    #ifdef DOUBLE_SIDED\n\n                        reflectedLight.directDiffuse = ( gl_FrontFacing ) ? vLightFront : vLightBack;\n\n                    #else\n\n                        reflectedLight.directDiffuse = vLightFront;\n\n                    #endif\n\n                    reflectedLight.directDiffuse *= BRDF_Diffuse_Lambert( diffuseColor.rgb ) * getShadowMask();\n\n                    // modulation\n                    #include <aomap_fragment>\n\n                    vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\n                    // #include <envmap_fragment>\n\n                    gl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\n                    // #include <tonemapping_fragment>\n                    // #include <encodings_fragment>\n                    #include <fog_fragment>\n                    #include <premultiplied_alpha_fragment>\n                    // #include <dithering_fragment>\n                }\n                    ",
    });
    Object.assign(j, new f.MeshLambertMaterial(h));
    j.isMeshLambertMaterial = true;
    j.setValues(h);
    return j;
  };
  f.CopyShader = {
    uniforms: {
      tDiffuse: {
        value: null,
      },
      opacity: {
        value: 1,
      },
    },
    vertexShader:
      "varying vec2 vUv;\nvoid main() {\n\tvUv = uv;\n\tgl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}",
    fragmentShader:
      "uniform float opacity;\nuniform sampler2D tDiffuse;\nvarying vec2 vUv;\nvoid main() {\n\tvec4 texel = texture2D( tDiffuse, vUv );\n\tgl_FragColor = opacity * texel;\n}",
  };
  f.EffectComposer = function (h, j, k) {
    this.renderer = h;
    if (j === undefined) {
      var l = {
        minFilter: f.LinearFilter,
        magFilter: f.LinearFilter,
        format: f.RGBAFormat,
        stencilBuffer: false,
      };
      var m = h.getSize(new f.Vector2());
      this._pixelRatio = h.getPixelRatio();
      this._width = m.width;
      this._height = m.height;
      (j = new f.WebGLRenderTarget(
        this._width * this._pixelRatio,
        this._height * this._pixelRatio,
        l,
      )).texture.name = "EffectComposer.rt1";
    } else {
      this._pixelRatio = 1;
      this._width = j.width;
      this._height = j.height;
    }
    this.renderTarget1 = j;
    this.renderTarget2 = j.clone();
    this.renderTarget2.texture.name = "EffectComposer.rt2";
    this.writeBuffer = this.renderTarget1;
    this.readBuffer = this.renderTarget2;
    this.renderToScreen = true;
    this.RENDER = k;
    this.passes = [];
    if (f.CopyShader === undefined) {
      console.error("THREE.EffectComposer relies on THREE.CopyShader");
    }
    if (f.ShaderPass === undefined) {
      console.error("THREE.EffectComposer relies on THREE.ShaderPass");
    }
    this.copyPass = new f.ShaderPass(f.CopyShader);
    this.clock = new f.Clock();
  };
  Object.assign(f.EffectComposer.prototype, {
    swapBuffers: function () {
      var h = this.readBuffer;
      this.readBuffer = this.writeBuffer;
      this.writeBuffer = h;
    },
    addPass: function (h) {
      this.passes.push(h);
      h.setSize(
        this._width * this._pixelRatio,
        this._height * this._pixelRatio,
      );
    },
    insertPass: function (h, j) {
      this.passes.splice(j, 0, h);
      h.setSize(
        this._width * this._pixelRatio,
        this._height * this._pixelRatio,
      );
    },
    replacePass: function (h, j) {
      this.passes[j] = h;
      h.setSize(
        this._width * this._pixelRatio,
        this._height * this._pixelRatio,
      );
    },
    isLastEnabledPass: function (h) {
      for (var j = h + 1; j < this.passes.length; j++) {
        if (this.passes[j].enabled) {
          return false;
        }
      }
      return true;
    },
    render: function (h = this.clock.getDelta()) {
      var j;
      var k;
      var m = this.renderer.getRenderTarget();
      var p = false;
      var q = this.passes.length;
      for (k = 0; k < q; k++) {
        if ((j = this.passes[k]).enabled !== false) {
          j.renderToScreen = this.renderToScreen && this.isLastEnabledPass(k);
          j.render(
            this.renderer,
            this.writeBuffer,
            this.readBuffer,
            h,
            p,
            this.RENDER,
          );
          if (j.needsSwap) {
            if (p) {
              var u = this.renderer.getContext();
              var v = this.renderer.state.buffers.stencil;
              v.setFunc(u.NOTEQUAL, 1, 4294967295);
              this.copyPass.render(
                this.renderer,
                this.writeBuffer,
                this.readBuffer,
                h,
              );
              v.setFunc(u.EQUAL, 1, 4294967295);
            }
            this.swapBuffers();
          }
          if (f.MaskPass !== undefined) {
            if (j instanceof f.MaskPass) {
              p = true;
            } else if (j instanceof f.ClearMaskPass) {
              p = false;
            }
          }
        }
      }
      this.renderer.setRenderTarget(m);
    },
    reset: function (h) {
      if (h === undefined) {
        var j = this.renderer.getSize(new f.Vector2());
        this._pixelRatio = this.renderer.getPixelRatio();
        this._width = j.width;
        this._height = j.height;
        (h = this.renderTarget1.clone()).setSize(
          this._width * this._pixelRatio,
          this._height * this._pixelRatio,
        );
      }
      this.renderTarget1.dispose();
      this.renderTarget2.dispose();
      this.renderTarget1 = h;
      this.renderTarget2 = h.clone();
      this.writeBuffer = this.renderTarget1;
      this.readBuffer = this.renderTarget2;
    },
    setSize: function (h, j) {
      this._width = h;
      this._height = j;
      var k = this._width * this._pixelRatio;
      var l = this._height * this._pixelRatio;
      this.renderTarget1.setSize(k, l);
      this.renderTarget2.setSize(k, l);
      for (var m = 0; m < this.passes.length; m++) {
        this.passes[m].setSize(k, l);
      }
    },
    setPixelRatio: function (h) {
      this._pixelRatio = h;
      this.setSize(this._width, this._height);
    },
  });
  f.Pass = function () {
    this.enabled = true;
    this.needsSwap = true;
    this.clear = false;
    this.renderToScreen = false;
  };
  Object.assign(f.Pass.prototype, {
    setSize: function () {},
    render: function () {
      console.error(
        "THREE.Pass: .render() must be implemented in derived pass.",
      );
    },
  });
  f.Pass.FullScreenQuad = (function () {
    var h = new f.OrthographicCamera(-1, 1, 1, -1, 0, 1);
    var j = new f.PlaneBufferGeometry(2, 2);
    function k(l) {
      this._mesh = new f.Mesh(j, l);
    }
    Object.defineProperty(k.prototype, "material", {
      get: function () {
        return this._mesh.material;
      },
      set: function (l) {
        this._mesh.material = l;
      },
    });
    Object.assign(k.prototype, {
      dispose: function () {
        this._mesh.geometry.dispose();
      },
      render: function (l) {
        l.render(this._mesh, h);
      },
    });
    return k;
  })();
  f.ShaderPass = function (h, j) {
    f.Pass.call(this);
    this.textureID = j === undefined ? "tDiffuse" : j;
    if (h instanceof f.ShaderMaterial) {
      this.uniforms = h.uniforms;
      this.material = h;
    } else if (h) {
      this.uniforms = f.UniformsUtils.clone(h.uniforms);
      this.material = new f.ShaderMaterial({
        defines: Object.assign({}, h.defines),
        uniforms: this.uniforms,
        vertexShader: h.vertexShader,
        fragmentShader: h.fragmentShader,
      });
    }
    this.clock = new f.Clock();
    this.fsQuad = new f.Pass.FullScreenQuad(this.material);
  };
  new f.Vector2();
  f.ShaderPass.prototype = Object.assign(Object.create(f.Pass.prototype), {
    constructor: f.ShaderPass,
    render: function (h, j, k, l, m, o) {
      if (this.uniforms[this.textureID]) {
        this.uniforms[this.textureID].value = k.texture;
      }
      if (this.uniforms.time == null) {
        this.uniforms.time = {
          type: "1f",
          value: this.clock.getElapsedTime(),
        };
      } else {
        this.uniforms.time.value = this.clock.getElapsedTime();
      }
      if (this.uniforms.delta == null) {
        this.uniforms.delta = {
          type: "1f",
          value: l,
        };
      } else {
        this.uniforms.delta.value = l;
      }
      if (this.uniforms.mouse == null) {
        this.uniforms.mouse = {
          value: o.tmpMouse,
        };
      } else {
        this.uniforms.mouse.value = o.tmpMouse;
      }
      if (this.uniforms.frame == null) {
        this.uniforms.frame = {
          value: 1,
        };
      } else {
        this.uniforms.frame.value++;
      }
      this.fsQuad.material = this.material;
      if (this.renderToScreen) {
        h.setRenderTarget(null);
        this.fsQuad.render(h);
      } else {
        h.setRenderTarget(j);
        if (this.clear) {
          h.clear(h.autoClearColor, h.autoClearDepth, h.autoClearStencil);
        }
        this.fsQuad.render(h);
      }
    },
  });
  f.RenderPass = function (h, j, k, l, m) {
    f.Pass.call(this);
    this.scene = h;
    this.camera = j;
    this.layer = 0;
    this.overrideMaterial = k;
    this.clearColor = l;
    this.clearAlpha = m === undefined ? 0 : m;
    this.clear = true;
    this.clearDepth = false;
    this.needsSwap = false;
  };
  f.RenderPass.prototype = Object.assign(Object.create(f.Pass.prototype), {
    constructor: f.RenderPass,
    render: function (h, j, k) {
      var l;
      var m;
      var o;
      var p = h.autoClear;
      h.autoClear = false;
      if (this.overrideMaterial !== undefined) {
        o = this.scene.overrideMaterial;
        this.scene.overrideMaterial = this.overrideMaterial;
      }
      if (this.clearColor) {
        l = h.getClearColor().getHex();
        m = h.getClearAlpha();
        h.setClearColor(this.clearColor, this.clearAlpha);
      }
      if (this.clearDepth) {
        h.clearDepth();
      }
      h.setRenderTarget(this.renderToScreen ? null : k);
      if (this.clear) {
        h.clear(h.autoClearColor, h.autoClearDepth, h.autoClearStencil);
      }
      if (this.layer) {
        this.camera.layers.set(this.layer);
      }
      h.render(this.scene, this.camera);
      if (this.clearColor) {
        h.setClearColor(l, m);
      }
      if (this.overrideMaterial !== undefined) {
        this.scene.overrideMaterial = o;
      }
      h.autoClear = p;
    },
  });
  class g extends f.RawShaderMaterial {
    constructor(h, j) {
      var k = j || {};
      k.aspectRatio = k.aspectRatio || 2;
      let m = 1500 / k.aspectRatio;
      k.width = 1500;
      k.hieght = m;
      let p = g.retriveUsedUniforms(h);
      var q = new f.Clock();
      super({
        vertexShader:
          "\n        attribute vec3 position;\n        attribute vec2 uv;\n        uniform mat4 projectionMatrix;\n        uniform mat4 modelViewMatrix;\n        varying vec2 vUv;\n        void main () {\n            gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);\n            vUv=uv;\n        }\n    ",
        fragmentShader: "",
      });
      if (p.iTime || p.iTimeDelta || p.iFrame || p.iDate) {
        if (p.iTime || p.iTimeDelta) {
          this.clock = q;
        }
        this.registerUpdate();
      }
      let u = this.createUniformsObject(p, k);
      this.uniforms = u.prof;
      var v =
        "\n        precision highp float;\n        uniform vec2 iResolution;\n        varying vec2 vUv;\n        vec4 texture(sampler2D sampler, vec2 coord){\n            return texture2D(sampler,  coord);\n        }\n        void  mainImage( out vec4,  vec2 fragCoord );\n        void main () {\n            vec4 outfrag;\n            mainImage(outfrag,iResolution*vUv);\n            gl_FragColor = outfrag;\n        }\n    \n" +
        u.code +
        "\n" +
        h;
      this.fragmentShader = v;
    }
    registerUpdate() {
      setTimeout(() => this.update(), 0);
    }
    update() {
      if (this.uniforms.iTime) {
        this.uniforms.iTime.value = this.clock.getElapsedTime();
      }
      if (this.uniforms.iTimeDelta) {
        this.uniforms.iTimeDelta.value = this.clock.getDelta();
      }
      if (this.uniforms.iFrame) {
        ++this.uniforms.iFrame.value;
      }
      if (this.uniforms.iDate) {
        let h = new Date();
        let j = h.getSeconds() + h.getMinutes() * 60 + h.getHours() * 3600;
        this.uniforms.iDate.value = new f.Vector4(
          h.getFullYear(),
          h.getMonth(),
          h.getDay(),
          j,
        );
      }
      if (this.uniforms.iChannelResolution) {
        let k = (l) => {
          if (
            this.uniforms["iChannel" + l] &&
            this.uniforms["iChannel" + l].value.image
          ) {
            this.uniforms.iChannelResolution.value[l] = new f.Vector3(
              this.uniforms["iChannel" + l].value.image.width,
              this.uniforms["iChannel" + l].value.image.height,
            );
          }
        };
        for (let l = 0; l < 4; l++) {
          k(l);
        }
      }
      requestAnimationFrame(() => {
        this.update();
      });
    }
    static retriveUsedUniforms(h) {
      let j = h.replace(d(), "");
      let k = {};
      [
        "iTime",
        "iTimeDelta",
        "iResolution",
        "iFrame",
        "iChannelTime[4]",
        "iChannelResolution",
        "iChannel0",
        "iChannel1",
        "iChannel2",
        "iChannel3",
        "iDate",
        "iMouse",
      ].forEach((l) => {
        if (j.includes(l)) {
          k[l] = true;
        }
      });
      return k;
    }
    createUniformsObject(h, j) {
      function k(o) {
        if (h["iChannel" + o]) {
          let p = j.map ? j.map : null;
          p = Array.isArray(p) ? p[o] : p;
          l["iChannel" + o] = {
            type: "t",
            value: p,
          };
          m += "uniform sampler2D " + ["iChannel" + o] + ";\n";
        }
      }
      let l = {};
      let m = "";
      if (h.iResolution) {
        l.iResolution = {
          value: new f.Vector2(j.width, j.hieght),
        };
      }
      if (h.iTime) {
        l.iTime = {
          type: "1f",
          value: this.clock.getElapsedTime(),
        };
        m += "uniform float iTime;\n";
      }
      if (h.iDate) {
        l.iDate = {
          value: new f.Vector4(),
        };
        m += "uniform vec4 iDate;\n";
      }
      if (h.iTimeDelta) {
        l.iTimeDelta = {
          type: "1f",
          value: this.clock.getDelta(),
        };
        m += "uniform float iTimeDelta;\n";
      }
      if (h.iFrame) {
        l.iFrame = {
          type: "1i",
          value: 0,
        };
        m += "uniform int iFrame;\n";
      }
      if (h.iMouse) {
        l.iMouse = {
          value: new f.Vector4(
            j.width / 2,
            j.hieght / 2,
            j.width / 2,
            j.hieght / 2,
          ),
        };
        m += "uniform vec4 iMouse;\n";
      }
      if (h.iChannelResolution) {
        l.iChannelResolution = {
          type: "v3v",
          value: [
            new f.Vector3(),
            new f.Vector3(),
            new f.Vector3(),
            new f.Vector3(),
          ],
        };
        m += "uniform vec3 iChannelResolution[4];\n";
      }
      for (let o = 0; o < 4; o++) {
        k(o);
      }
      return {
        prof: l,
        code: m,
      };
    }
  }
  f.ShaderToyMaterial = g;
  f.SAOShader = {
    defines: {
      NUM_SAMPLES: 7,
      NUM_RINGS: 4,
      NORMAL_TEXTURE: 0,
      DIFFUSE_TEXTURE: 0,
      DEPTH_PACKING: 1,
      PERSPECTIVE_CAMERA: 1,
    },
    uniforms: {
      tDepth: {
        value: null,
      },
      tDiffuse: {
        value: null,
      },
      tNormal: {
        value: null,
      },
      size: {
        value: new f.Vector2(512, 512),
      },
      cameraNear: {
        value: 1,
      },
      cameraFar: {
        value: 100,
      },
      cameraProjectionMatrix: {
        value: new f.Matrix4(),
      },
      cameraInverseProjectionMatrix: {
        value: new f.Matrix4(),
      },
      scale: {
        value: 1,
      },
      intensity: {
        value: 0.1,
      },
      bias: {
        value: 0.5,
      },
      minResolution: {
        value: 0,
      },
      kernelRadius: {
        value: 100,
      },
      randomSeed: {
        value: 0,
      },
    },
    vertexShader:
      "varying vec2 vUv;\nvoid main() {\n\tvUv = uv;\n\tgl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}",
    fragmentShader:
      "#include <common>\nvarying vec2 vUv;\n#if DIFFUSE_TEXTURE == 1\nuniform sampler2D tDiffuse;\n#endif\nuniform sampler2D tDepth;\n#if NORMAL_TEXTURE == 1\nuniform sampler2D tNormal;\n#endif\nuniform float cameraNear;\nuniform float cameraFar;\nuniform mat4 cameraProjectionMatrix;\nuniform mat4 cameraInverseProjectionMatrix;\nuniform float scale;\nuniform float intensity;\nuniform float bias;\nuniform float kernelRadius;\nuniform float minResolution;\nuniform vec2 size;\nuniform float randomSeed;\n// RGBA depth\n#include <packing>\nvec4 getDefaultColor( const in vec2 screenPosition ) {\n\t#if DIFFUSE_TEXTURE == 1\n\treturn texture2D( tDiffuse, vUv );\n\t#else\n\treturn vec4( 1.0 );\n\t#endif\n}\nfloat getDepth( const in vec2 screenPosition ) {\n\t#if DEPTH_PACKING == 1\n\treturn unpackRGBAToDepth( texture2D( tDepth, screenPosition ) );\n\t#else\n\treturn texture2D( tDepth, screenPosition ).x;\n\t#endif\n}\nfloat getViewZ( const in float depth ) {\n\t#if PERSPECTIVE_CAMERA == 1\n\treturn perspectiveDepthToViewZ( depth, cameraNear, cameraFar );\n\t#else\n\treturn orthographicDepthToViewZ( depth, cameraNear, cameraFar );\n\t#endif\n}\nvec3 getViewPosition( const in vec2 screenPosition, const in float depth, const in float viewZ ) {\n\tfloat clipW = cameraProjectionMatrix[2][3] * viewZ + cameraProjectionMatrix[3][3];\n\tvec4 clipPosition = vec4( ( vec3( screenPosition, depth ) - 0.5 ) * 2.0, 1.0 );\n\tclipPosition *= clipW; // unprojection.\n\treturn ( cameraInverseProjectionMatrix * clipPosition ).xyz;\n}\nvec3 getViewNormal( const in vec3 viewPosition, const in vec2 screenPosition ) {\n\t#if NORMAL_TEXTURE == 1\n\treturn unpackRGBToNormal( texture2D( tNormal, screenPosition ).xyz );\n\t#else\n\treturn normalize( cross( dFdx( viewPosition ), dFdy( viewPosition ) ) );\n\t#endif\n}\nfloat scaleDividedByCameraFar;\nfloat minResolutionMultipliedByCameraFar;\nfloat getOcclusion( const in vec3 centerViewPosition, const in vec3 centerViewNormal, const in vec3 sampleViewPosition ) {\n\tvec3 viewDelta = sampleViewPosition - centerViewPosition;\n\tfloat viewDistance = length( viewDelta );\n\tfloat scaledScreenDistance = scaleDividedByCameraFar * viewDistance;\n\treturn max(0.0, (dot(centerViewNormal, viewDelta) - minResolutionMultipliedByCameraFar) / scaledScreenDistance - bias) / (1.0 + pow2( scaledScreenDistance ) );\n}\n// moving costly divides into consts\nconst float ANGLE_STEP = PI2 * float( NUM_RINGS ) / float( NUM_SAMPLES );\nconst float INV_NUM_SAMPLES = 1.0 / float( NUM_SAMPLES );\nfloat getAmbientOcclusion( const in vec3 centerViewPosition ) {\n\t// precompute some variables require in getOcclusion.\n\tscaleDividedByCameraFar = scale / cameraFar;\n\tminResolutionMultipliedByCameraFar = minResolution * cameraFar;\n\tvec3 centerViewNormal = getViewNormal( centerViewPosition, vUv );\n\t// jsfiddle that shows sample pattern: https://jsfiddle.net/a16ff1p7/\n\tfloat angle = rand( vUv + randomSeed ) * PI2;\n\tvec2 radius = vec2( kernelRadius * INV_NUM_SAMPLES ) / size;\n\tvec2 radiusStep = radius;\n\tfloat occlusionSum = 0.0;\n\tfloat weightSum = 0.0;\n\tfor( int i = 0; i < NUM_SAMPLES; i ++ ) {\n\t\tvec2 sampleUv = vUv + vec2( cos( angle ), sin( angle ) ) * radius;\n\t\tradius += radiusStep;\n\t\tangle += ANGLE_STEP;\n\t\tfloat sampleDepth = getDepth( sampleUv );\n\t\tif( sampleDepth >= ( 1.0 - EPSILON ) ) {\n\t\t\tcontinue;\n\t\t}\n\t\tfloat sampleViewZ = getViewZ( sampleDepth );\n\t\tvec3 sampleViewPosition = getViewPosition( sampleUv, sampleDepth, sampleViewZ );\n\t\tocclusionSum += getOcclusion( centerViewPosition, centerViewNormal, sampleViewPosition );\n\t\tweightSum += 1.0;\n\t}\n\tif( weightSum == 0.0 ) discard;\n\treturn occlusionSum * ( intensity / weightSum );\n}\nvoid main() {\n\tfloat centerDepth = getDepth( vUv );\n\tif( centerDepth >= ( 1.0 - EPSILON ) ) {\n\t\tdiscard;\n\t}\n\tfloat centerViewZ = getViewZ( centerDepth );\n\tvec3 viewPosition = getViewPosition( vUv, centerDepth, centerViewZ );\n\tfloat ambientOcclusion = getAmbientOcclusion( viewPosition );\n\tgl_FragColor = getDefaultColor( vUv );\n\tgl_FragColor.xyz *=  1.0 - ambientOcclusion;\n}",
  };
  f.UnpackDepthRGBAShader = {
    uniforms: {
      tDiffuse: {
        value: null,
      },
      opacity: {
        value: 1,
      },
    },
    vertexShader:
      "varying vec2 vUv;\nvoid main() {\n\tvUv = uv;\n\tgl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}",
    fragmentShader:
      "uniform float opacity;\nuniform sampler2D tDiffuse;\nvarying vec2 vUv;\n#include <packing>\nvoid main() {\n\tfloat depth = 1.0 - unpackRGBAToDepth( texture2D( tDiffuse, vUv ) );\n\tgl_FragColor = vec4( vec3( depth ), opacity );\n}",
  };
  f.DepthLimitedBlurShader = {
    defines: {
      KERNEL_RADIUS: 4,
      DEPTH_PACKING: 1,
      PERSPECTIVE_CAMERA: 1,
    },
    uniforms: {
      tDiffuse: {
        value: null,
      },
      size: {
        value: new f.Vector2(512, 512),
      },
      sampleUvOffsets: {
        value: [new f.Vector2(0, 0)],
      },
      sampleWeights: {
        value: [1],
      },
      tDepth: {
        value: null,
      },
      cameraNear: {
        value: 10,
      },
      cameraFar: {
        value: 1000,
      },
      depthCutoff: {
        value: 10,
      },
    },
    vertexShader:
      "#include <common>\nuniform vec2 size;\nvarying vec2 vUv;\nvarying vec2 vInvSize;\nvoid main() {\n\tvUv = uv;\n\tvInvSize = 1.0 / size;\n\tgl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}",
    fragmentShader:
      "#include <common>\n#include <packing>\nuniform sampler2D tDiffuse;\nuniform sampler2D tDepth;\nuniform float cameraNear;\nuniform float cameraFar;\nuniform float depthCutoff;\nuniform vec2 sampleUvOffsets[ KERNEL_RADIUS + 1 ];\nuniform float sampleWeights[ KERNEL_RADIUS + 1 ];\nvarying vec2 vUv;\nvarying vec2 vInvSize;\nfloat getDepth( const in vec2 screenPosition ) {\n\t#if DEPTH_PACKING == 1\n\treturn unpackRGBAToDepth( texture2D( tDepth, screenPosition ) );\n\t#else\n\treturn texture2D( tDepth, screenPosition ).x;\n\t#endif\n}\nfloat getViewZ( const in float depth ) {\n\t#if PERSPECTIVE_CAMERA == 1\n\treturn perspectiveDepthToViewZ( depth, cameraNear, cameraFar );\n\t#else\n\treturn orthographicDepthToViewZ( depth, cameraNear, cameraFar );\n\t#endif\n}\nvoid main() {\n\tfloat depth = getDepth( vUv );\n\tif( depth >= ( 1.0 - EPSILON ) ) {\n\t\tdiscard;\n\t}\n\tfloat centerViewZ = -getViewZ( depth );\n\tbool rBreak = false, lBreak = false;\n\tfloat weightSum = sampleWeights[0];\n\tvec4 diffuseSum = texture2D( tDiffuse, vUv ) * weightSum;\n\tfor( int i = 1; i <= KERNEL_RADIUS; i ++ ) {\n\t\tfloat sampleWeight = sampleWeights[i];\n\t\tvec2 sampleUvOffset = sampleUvOffsets[i] * vInvSize;\n\t\tvec2 sampleUv = vUv + sampleUvOffset;\n\t\tfloat viewZ = -getViewZ( getDepth( sampleUv ) );\n\t\tif( abs( viewZ - centerViewZ ) > depthCutoff ) rBreak = true;\n\t\tif( ! rBreak ) {\n\t\t\tdiffuseSum += texture2D( tDiffuse, sampleUv ) * sampleWeight;\n\t\t\tweightSum += sampleWeight;\n\t\t}\n\t\tsampleUv = vUv - sampleUvOffset;\n\t\tviewZ = -getViewZ( getDepth( sampleUv ) );\n\t\tif( abs( viewZ - centerViewZ ) > depthCutoff ) lBreak = true;\n\t\tif( ! lBreak ) {\n\t\t\tdiffuseSum += texture2D( tDiffuse, sampleUv ) * sampleWeight;\n\t\t\tweightSum += sampleWeight;\n\t\t}\n\t}\n\tgl_FragColor = diffuseSum / weightSum;\n}",
  };
  f.BlurShaderUtils = {
    createSampleWeights: function (h, j) {
      function k(o, p) {
        return Math.exp((-o * o) / (p * p * 2)) / (Math.sqrt(Math.PI * 2) * p);
      }
      var l = [];
      for (var m = 0; m <= h; m++) {
        l.push(k(m, j));
      }
      return l;
    },
    createSampleOffsets: function (h, j) {
      var k = [];
      for (var l = 0; l <= h; l++) {
        k.push(j.clone().multiplyScalar(l));
      }
      return k;
    },
    configure: function (h, j, k, l) {
      h.defines.KERNEL_RADIUS = j;
      h.uniforms.sampleUvOffsets.value = f.BlurShaderUtils.createSampleOffsets(
        j,
        l,
      );
      h.uniforms.sampleWeights.value = f.BlurShaderUtils.createSampleWeights(
        j,
        k,
      );
      h.needsUpdate = true;
    },
  };
  f.SAOPass = function (h, j, k, l, m) {
    f.Pass.call(this);
    this.scene = h;
    this.camera = j;
    this.clear = true;
    this.needsSwap = false;
    this.supportsDepthTextureExtension = k !== undefined && k;
    this.supportsNormalTexture = l !== undefined && l;
    this.originalClearColor = new f.Color();
    this.oldClearColor = new f.Color();
    this.oldClearAlpha = 1;
    this.params = {
      output: 0,
      saoBias: 0.5,
      saoIntensity: 0.18,
      saoScale: 1,
      saoKernelRadius: 100,
      saoMinResolution: 0,
      saoBlur: true,
      saoBlurRadius: 8,
      saoBlurStdDev: 4,
      saoBlurDepthCutoff: 0.01,
    };
    this.resolution =
      m === undefined ? new f.Vector2(256, 256) : new f.Vector2(m.x, m.y);
    this.saoRenderTarget = new f.WebGLRenderTarget(
      this.resolution.x,
      this.resolution.y,
      {
        minFilter: f.LinearFilter,
        magFilter: f.LinearFilter,
        format: f.RGBAFormat,
      },
    );
    this.blurIntermediateRenderTarget = this.saoRenderTarget.clone();
    this.beautyRenderTarget = this.saoRenderTarget.clone();
    this.normalRenderTarget = new f.WebGLRenderTarget(
      this.resolution.x,
      this.resolution.y,
      {
        minFilter: f.NearestFilter,
        magFilter: f.NearestFilter,
        format: f.RGBAFormat,
      },
    );
    this.depthRenderTarget = this.normalRenderTarget.clone();
    if (this.supportsDepthTextureExtension) {
      (k = new f.DepthTexture()).type = f.UnsignedShortType;
      k.minFilter = f.NearestFilter;
      k.maxFilter = f.NearestFilter;
      this.beautyRenderTarget.depthTexture = k;
      this.beautyRenderTarget.depthBuffer = true;
    }
    this.depthMaterial = new f.MeshDepthMaterial();
    this.depthMaterial.depthPacking = f.RGBADepthPacking;
    this.depthMaterial.blending = f.NoBlending;
    this.normalMaterial = new f.MeshNormalMaterial();
    this.normalMaterial.blending = f.NoBlending;
    if (f.SAOShader === undefined) {
      console.error("THREE.SAOPass relies on THREE.SAOShader");
    }
    this.saoMaterial = new f.ShaderMaterial({
      defines: Object.assign({}, f.SAOShader.defines),
      fragmentShader: f.SAOShader.fragmentShader,
      vertexShader: f.SAOShader.vertexShader,
      uniforms: f.UniformsUtils.clone(f.SAOShader.uniforms),
    });
    this.saoMaterial.extensions.derivatives = true;
    this.saoMaterial.defines.DEPTH_PACKING = this.supportsDepthTextureExtension
      ? 0
      : 1;
    this.saoMaterial.defines.NORMAL_TEXTURE = this.supportsNormalTexture
      ? 1
      : 0;
    this.saoMaterial.defines.PERSPECTIVE_CAMERA = this.camera
      .isPerspectiveCamera
      ? 1
      : 0;
    this.saoMaterial.uniforms.tDepth.value = this.supportsDepthTextureExtension
      ? k
      : this.depthRenderTarget.texture;
    this.saoMaterial.uniforms.tNormal.value = this.normalRenderTarget.texture;
    this.saoMaterial.uniforms.size.value.set(
      this.resolution.x,
      this.resolution.y,
    );
    this.saoMaterial.uniforms.cameraInverseProjectionMatrix.value.getInverse(
      this.camera.projectionMatrix,
    );
    this.saoMaterial.uniforms.cameraProjectionMatrix.value =
      this.camera.projectionMatrix;
    this.saoMaterial.blending = f.NoBlending;
    if (f.DepthLimitedBlurShader === undefined) {
      console.error("THREE.SAOPass relies on THREE.DepthLimitedBlurShader");
    }
    this.vBlurMaterial = new f.ShaderMaterial({
      uniforms: f.UniformsUtils.clone(f.DepthLimitedBlurShader.uniforms),
      defines: Object.assign({}, f.DepthLimitedBlurShader.defines),
      vertexShader: f.DepthLimitedBlurShader.vertexShader,
      fragmentShader: f.DepthLimitedBlurShader.fragmentShader,
    });
    this.vBlurMaterial.defines.DEPTH_PACKING = this
      .supportsDepthTextureExtension
      ? 0
      : 1;
    this.vBlurMaterial.defines.PERSPECTIVE_CAMERA = this.camera
      .isPerspectiveCamera
      ? 1
      : 0;
    this.vBlurMaterial.uniforms.tDiffuse.value = this.saoRenderTarget.texture;
    this.vBlurMaterial.uniforms.tDepth.value = this
      .supportsDepthTextureExtension
      ? k
      : this.depthRenderTarget.texture;
    this.vBlurMaterial.uniforms.size.value.set(
      this.resolution.x,
      this.resolution.y,
    );
    this.vBlurMaterial.blending = f.NoBlending;
    this.hBlurMaterial = new f.ShaderMaterial({
      uniforms: f.UniformsUtils.clone(f.DepthLimitedBlurShader.uniforms),
      defines: Object.assign({}, f.DepthLimitedBlurShader.defines),
      vertexShader: f.DepthLimitedBlurShader.vertexShader,
      fragmentShader: f.DepthLimitedBlurShader.fragmentShader,
    });
    this.hBlurMaterial.defines.DEPTH_PACKING = this
      .supportsDepthTextureExtension
      ? 0
      : 1;
    this.hBlurMaterial.defines.PERSPECTIVE_CAMERA = this.camera
      .isPerspectiveCamera
      ? 1
      : 0;
    this.hBlurMaterial.uniforms.tDiffuse.value =
      this.blurIntermediateRenderTarget.texture;
    this.hBlurMaterial.uniforms.tDepth.value = this
      .supportsDepthTextureExtension
      ? k
      : this.depthRenderTarget.texture;
    this.hBlurMaterial.uniforms.size.value.set(
      this.resolution.x,
      this.resolution.y,
    );
    this.hBlurMaterial.blending = f.NoBlending;
    if (f.CopyShader === undefined) {
      console.error("THREE.SAOPass relies on THREE.CopyShader");
    }
    this.materialCopy = new f.ShaderMaterial({
      uniforms: f.UniformsUtils.clone(f.CopyShader.uniforms),
      vertexShader: f.CopyShader.vertexShader,
      fragmentShader: f.CopyShader.fragmentShader,
      blending: f.NoBlending,
    });
    this.materialCopy.transparent = true;
    this.materialCopy.depthTest = false;
    this.materialCopy.depthWrite = false;
    this.materialCopy.blending = f.CustomBlending;
    this.materialCopy.blendSrc = f.DstColorFactor;
    this.materialCopy.blendDst = f.ZeroFactor;
    this.materialCopy.blendEquation = f.AddEquation;
    this.materialCopy.blendSrcAlpha = f.DstAlphaFactor;
    this.materialCopy.blendDstAlpha = f.ZeroFactor;
    this.materialCopy.blendEquationAlpha = f.AddEquation;
    if (f.UnpackDepthRGBAShader === undefined) {
      console.error("THREE.SAOPass relies on THREE.UnpackDepthRGBAShader");
    }
    this.depthCopy = new f.ShaderMaterial({
      uniforms: f.UniformsUtils.clone(f.UnpackDepthRGBAShader.uniforms),
      vertexShader: f.UnpackDepthRGBAShader.vertexShader,
      fragmentShader: f.UnpackDepthRGBAShader.fragmentShader,
      blending: f.NoBlending,
    });
    this.fsQuad = new f.Pass.FullScreenQuad(null);
  };
  f.SAOPass.OUTPUT = {
    Beauty: 1,
    Default: 0,
    SAO: 2,
    Depth: 3,
    Normal: 4,
  };
  f.SAOPass.prototype = Object.assign(Object.create(f.Pass.prototype), {
    constructor: f.SAOPass,
    render: function (h, j, k) {
      if (this.renderToScreen) {
        this.materialCopy.blending = f.NoBlending;
        this.materialCopy.uniforms.tDiffuse.value = k.texture;
        this.materialCopy.needsUpdate = true;
        this.renderPass(h, this.materialCopy, null);
      }
      if (this.params.output !== 1) {
        this.oldClearColor.copy(h.getClearColor());
        this.oldClearAlpha = h.getClearAlpha();
        var l = h.autoClear;
        h.autoClear = false;
        h.setRenderTarget(this.depthRenderTarget);
        h.clear();
        this.saoMaterial.uniforms.bias.value = this.params.saoBias;
        this.saoMaterial.uniforms.intensity.value = this.params.saoIntensity;
        this.saoMaterial.uniforms.scale.value = this.params.saoScale;
        this.saoMaterial.uniforms.kernelRadius.value =
          this.params.saoKernelRadius;
        this.saoMaterial.uniforms.minResolution.value =
          this.params.saoMinResolution;
        this.saoMaterial.uniforms.cameraNear.value = this.camera.near;
        this.saoMaterial.uniforms.cameraFar.value = this.camera.far;
        var m =
          this.params.saoBlurDepthCutoff * (this.camera.far - this.camera.near);
        this.vBlurMaterial.uniforms.depthCutoff.value = m;
        this.hBlurMaterial.uniforms.depthCutoff.value = m;
        this.vBlurMaterial.uniforms.cameraNear.value = this.camera.near;
        this.vBlurMaterial.uniforms.cameraFar.value = this.camera.far;
        this.hBlurMaterial.uniforms.cameraNear.value = this.camera.near;
        this.hBlurMaterial.uniforms.cameraFar.value = this.camera.far;
        this.params.saoBlurRadius = Math.floor(this.params.saoBlurRadius);
        if (
          this.prevStdDev !== this.params.saoBlurStdDev ||
          this.prevNumSamples !== this.params.saoBlurRadius
        ) {
          f.BlurShaderUtils.configure(
            this.vBlurMaterial,
            this.params.saoBlurRadius,
            this.params.saoBlurStdDev,
            new f.Vector2(0, 1),
          );
          f.BlurShaderUtils.configure(
            this.hBlurMaterial,
            this.params.saoBlurRadius,
            this.params.saoBlurStdDev,
            new f.Vector2(1, 0),
          );
          this.prevStdDev = this.params.saoBlurStdDev;
          this.prevNumSamples = this.params.saoBlurRadius;
        }
        h.setClearColor(0);
        h.setRenderTarget(this.beautyRenderTarget);
        h.clear();
        h.render(this.scene, this.camera);
        if (!this.supportsDepthTextureExtension) {
          this.renderOverride(
            h,
            this.depthMaterial,
            this.depthRenderTarget,
            0,
            1,
          );
        }
        if (this.supportsNormalTexture) {
          this.renderOverride(
            h,
            this.normalMaterial,
            this.normalRenderTarget,
            7829503,
            1,
          );
        }
        this.renderPass(h, this.saoMaterial, this.saoRenderTarget, 16777215, 1);
        if (this.params.saoBlur) {
          this.renderPass(
            h,
            this.vBlurMaterial,
            this.blurIntermediateRenderTarget,
            16777215,
            1,
          );
          this.renderPass(
            h,
            this.hBlurMaterial,
            this.saoRenderTarget,
            16777215,
            1,
          );
        }
        var o = this.materialCopy;
        if (this.params.output === 3) {
          if (this.supportsDepthTextureExtension) {
            this.materialCopy.uniforms.tDiffuse.value =
              this.beautyRenderTarget.depthTexture;
            this.materialCopy.needsUpdate = true;
          } else {
            this.depthCopy.uniforms.tDiffuse.value =
              this.depthRenderTarget.texture;
            this.depthCopy.needsUpdate = true;
            o = this.depthCopy;
          }
        } else if (this.params.output === 4) {
          this.materialCopy.uniforms.tDiffuse.value =
            this.normalRenderTarget.texture;
          this.materialCopy.needsUpdate = true;
        } else {
          this.materialCopy.uniforms.tDiffuse.value =
            this.saoRenderTarget.texture;
          this.materialCopy.needsUpdate = true;
        }
        o.blending = this.params.output === 0 ? f.CustomBlending : f.NoBlending;
        this.renderPass(h, o, this.renderToScreen ? null : k);
        h.setClearColor(this.oldClearColor, this.oldClearAlpha);
        h.autoClear = l;
      }
    },
    renderPass: function (h, j, k, l, m) {
      this.originalClearColor.copy(h.getClearColor());
      var o = h.getClearAlpha();
      var p = h.autoClear;
      h.setRenderTarget(k);
      h.autoClear = false;
      if (l != null) {
        h.setClearColor(l);
        h.setClearAlpha(m || 0);
        h.clear();
      }
      this.fsQuad.material = j;
      this.fsQuad.render(h);
      h.autoClear = p;
      h.setClearColor(this.originalClearColor);
      h.setClearAlpha(o);
    },
    renderOverride: function (h, j, k, l, m) {
      this.originalClearColor.copy(h.getClearColor());
      var o = h.getClearAlpha();
      var p = h.autoClear;
      h.setRenderTarget(k);
      h.autoClear = false;
      l = j.clearColor || l;
      m = j.clearAlpha || m;
      if (l != null) {
        h.setClearColor(l);
        h.setClearAlpha(m || 0);
        h.clear();
      }
      this.scene.overrideMaterial = j;
      h.render(this.scene, this.camera);
      this.scene.overrideMaterial = null;
      h.autoClear = p;
      h.setClearColor(this.originalClearColor);
      h.setClearAlpha(o);
    },
    setSize: function (h, j) {
      this.beautyRenderTarget.setSize(h, j);
      this.saoRenderTarget.setSize(h, j);
      this.blurIntermediateRenderTarget.setSize(h, j);
      this.normalRenderTarget.setSize(h, j);
      this.depthRenderTarget.setSize(h, j);
      this.saoMaterial.uniforms.size.value.set(h, j);
      this.saoMaterial.uniforms.cameraInverseProjectionMatrix.value.getInverse(
        this.camera.projectionMatrix,
      );
      this.saoMaterial.uniforms.cameraProjectionMatrix.value =
        this.camera.projectionMatrix;
      this.saoMaterial.needsUpdate = true;
      this.vBlurMaterial.uniforms.size.value.set(h, j);
      this.vBlurMaterial.needsUpdate = true;
      this.hBlurMaterial.uniforms.size.value.set(h, j);
      this.hBlurMaterial.needsUpdate = true;
    },
  });
};
